import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CountdownModule } from 'ngx-countdown';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { ComponentsModule } from '../core/components/components.module';
import { InserirInformacoesLaudoComponent } from './inserir-informacoes-laudo/inserir-informacoes-laudo.component';
import { VisualizarLaudoComponent } from './laudo-higienizacao/visualizar-laudo/visualizar-laudo.component';
import { NotFoundComponent } from './not-found/not-found.component';

@NgModule({
  declarations: [
    InserirInformacoesLaudoComponent,
    VisualizarLaudoComponent,
    NotFoundComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CountdownModule,
    PdfViewerModule,
    ComponentsModule
  ],
  exports: [
    InserirInformacoesLaudoComponent,
    VisualizarLaudoComponent,
    NotFoundComponent
  ]
})
export class PagesModule {}
